import HTTPServices from "../HTTPServices/httpService";

const productService = {
  // //(**) Get product Item by GUID
  // getByGUID: async function (guid) {
  //   console.log("'getByGUID' service called: '");
  //   let result = await HTTPServices.post(
  //     "ProductItem/getByID",
  //     guid
  //   );
  //   console.log("retrun result --->" + JSON.stringify(result));
  //   return result;
  // },

  //(**) Get product Item by GUID
  getByGUID: async function (guid) {
    console.log("'getByGUID' service called: '");
    let result = await HTTPServices.get("ProductItem/getByID/" + guid);
    console.log("retrun result --->" + JSON.stringify(result));
    return result;
  },

  //(**) 1. Get PRoduct with Charge
  getAllProductWithMakingCharge: async function () {
    console.log("'getAllProductWithMakingCharge' service called: '");
    let result = await HTTPServices.post(
      "ProductItem/getAllProductsWithMakingCharge",
      ""
    );
    console.log("retrun result --->" + JSON.stringify(result));
    return result;
  },

  //(**) 2.a. Get Accessories with Charge
  getAllAccessoriesWithPrice: async function () {
    console.log("'ProductItem/getAllAccessoriesWithPrice' service called: '");
    let result = await HTTPServices.post(
      "ProductItem/getAllAccessoriesWithPrice",
      ""
    );
    console.log("'ProductItem/getAllAccessoriesWithPrice' : retrun result --->" + JSON.stringify(result));
    return result;
  },

   //(**) 2.b. Get Accessories with Charge
   searchAllAccessoriesWithPrice: async function (searchWord) {
    console.log("'ProductItem/searchAllAccessoriesWithPrice' service called: '");
    let result = await HTTPServices.post(
      "ProductItem/searchAllAccessoriesWithPrice",
      searchWord
    );
    console.log("'ProductItem/getAllAccessoriesWithPrice' : retrun result --->" + JSON.stringify(result));
    return result;
  },

  //(2)
  save: async function (savingObj) {
    console.log(
      "'productService' service called: save : " + JSON.stringify(savingObj)
    );
    let productItemSaved = await HTTPServices.post(
      "ProductItem/save",
      savingObj
    );
    // customer.then((result) => {
    //   debugger;
    //   console.log("Promised result: " + result); // "Some desired value"
    //   return result;
    // });

    return productItemSaved;
  },
};

export default productService;
